import axiosInstance from './axiosInstance';

/**
 * Fetch audit log entries with optional filters.
 * Server returns { data, pagination, stats }.
 */
export const fetchAuditLogs = async (params = {}) => {
  const res = await axiosInstance.get('/admin/audit-logs', { params });
  return res.data;
};
